/**
 * **통계의 기간 — 공성률 그래프 밑 스크롤바로 고른 최근 몇 판** (사용자 2026-10-27).
 * 서버에는 고른 첫 판의 시작일을 `since` 로 넘긴다(backend utils/season.ts sinceSieges).
 */

/**
 * 기간이 짧으면 '몇 회 이상' 문턱도 그만큼 줄인다 — 점령전 한 판에서 같은 덱을 10번 만나는 일은 드물어 목록이 비었다.
 * 30판 이상(또는 전체)이면 base, 그보다 짧으면 비례해서 줄이되 1 아래로는 안 내린다.
 */
export const minForPeriod = (base: number, recent: number) =>
    recent > 0 && recent < 30 ? Math.max(1, Math.round((base * recent) / 30)) : base;
